import React, { useState } from 'react';
import Base from '../Base';
import {
    Container,
    Row,
    Col,
    Breadcrumb,
    Tab,
    Tabs
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import UploadStatusTab from './UploadStatusTab';
import ReportsTab from './ReportsTab';
import './UploadStatusPage.css';
import PreviousPeriodTab from './PreviousPeriodTab';
import MissingRecordsTab from './MissingRecordsTab';
import { useParams } from 'react-router-dom';

function UploadStatusPage() {
    const [activeTab, setActiveTab] = useState('reports');
    const { client_id } = useParams();
    return (
        <Base>
            <Container fluid className="p-4 bg-light min-vh-100">
                <Row>
                    <Col xs={12}>
                        <Breadcrumb>
                            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/" }}>
                                Dashboard
                            </Breadcrumb.Item>
                            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/clients" }}>
                                Clients
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                                linkAs={NavLink}
                                linkProps={{ to: `/clients/tax-forms/${client_id}` }}
                            >
                                Tax-Forms
                            </Breadcrumb.Item>
                            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: `/RoDTEP/RoSCTL/${client_id}` }}>
                                RoDTEP/RoSCTL
                            </Breadcrumb.Item>
                            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: `/RoDTEP/RoSCTL/status/${client_id}` }}>
                                Upload Status
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Reports</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12}>
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(k)}
                            className="mb-4 custom-tabs"
                        >
                            <Tab eventKey="reports" title="Reports">
                                {activeTab === 'reports' && <ReportsTab />}
                            </Tab>

                            <Tab eventKey="previous-period" title="Previous Period Data">
                                {activeTab === 'previous-period' && <PreviousPeriodTab />}
                            </Tab>

                            <Tab eventKey="missing-records" title="Missing in ICEGATE">
                                {activeTab === 'missing-records' && <MissingRecordsTab />}
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        </Base>
    );
}

export default UploadStatusPage;